export const DOCUMENT_TYPES = {
  ID_CARD: "IdCard",
  PASSPORT: "Passport",
  RESIDENCE_PERMIT: "ResidencePermit",
  DRIVER_LICENSE: "DriverLicense",
  INTERNAL_PASSPORT: "InternalPassport",
  SOCIAL_ID: "SocialId"
};

export const DOCUMENT_SUB_TYPES = {
  REGULAR: "Regular",
  SERVICE: "Service",
  EMERGENCY: "Emergency",
  REFUGEE: "Refugee",
  STATELESS: "Stateless",
  ALIEN: "Alien",
  TRAVEL: "Travel",
  SPECIAL: "Special",
  PROVISIONAL: "Provisional",
  TEMPORARY: "Temporary",
  DIPLOMATIC: "Diplomatic",
  PROVISIONAL_LEARNER: "ProvisionalLearner",
  PERMANENT: "Permanent",
  NON_REGULAR: "NonRegular"
};

export const DOCUMENT_TYPE_SUB_TYPES = {
  [DOCUMENT_TYPES.PASSPORT]: [DOCUMENT_SUB_TYPES.REGULAR, DOCUMENT_SUB_TYPES.DIPLOMATIC, DOCUMENT_SUB_TYPES.SERVICE, DOCUMENT_SUB_TYPES.EMERGENCY, DOCUMENT_SUB_TYPES.REFUGEE, DOCUMENT_SUB_TYPES.STATELESS, DOCUMENT_SUB_TYPES.ALIEN, DOCUMENT_SUB_TYPES.TRAVEL, DOCUMENT_SUB_TYPES.SPECIAL, DOCUMENT_SUB_TYPES.PROVISIONAL],
  [DOCUMENT_TYPES.ID_CARD]: [DOCUMENT_SUB_TYPES.REGULAR, DOCUMENT_SUB_TYPES.TEMPORARY, DOCUMENT_SUB_TYPES.DIPLOMATIC, DOCUMENT_SUB_TYPES.TRAVEL, DOCUMENT_SUB_TYPES.SERVICE, DOCUMENT_SUB_TYPES.ALIEN, DOCUMENT_SUB_TYPES.EMERGENCY],
  [DOCUMENT_TYPES.RESIDENCE_PERMIT]: [DOCUMENT_SUB_TYPES.TEMPORARY, DOCUMENT_SUB_TYPES.PERMANENT],
  [DOCUMENT_TYPES.DRIVER_LICENSE]: [DOCUMENT_SUB_TYPES.REGULAR, DOCUMENT_SUB_TYPES.NON_REGULAR],
  [DOCUMENT_TYPES.INTERNAL_PASSPORT]: [DOCUMENT_SUB_TYPES.REGULAR]
};

export const GENDER_OPTIONS = {
  MALE: "M",
  FEMALE: "F",
  NOT_SPECIFIED: "X"
};

export const IDENTIFICATION_RULES = {
  HAS_QR: "DOCUMENT_HAS_QR",
  MRZ_VERIFIED: "MRZ_VERIFIED"
};

export const PROVIDER_TYPE = {
  NON_QUALIFIED: "NonQualified",
  PHOTO_IDENTIFICATION: "PhotoIdentification",
  ELECTRONIC_IDENTIFICATION: "ElectronicIdentification",
  BANK_BASED_IDENTIFICATION: "BankBasedIdentification",
  DIGITAL_IDENTITY_WALLET: "DigitalIdentityWallet"
};
